<template>
  <div :class="size">
    <fa
      v-if="isLoading"
      :icon="['fal', 'circle-notch']"
      class="text-md text-neutral-500 fa-spin"
    />
  </div>
</template>

<script>
export default {
  name: 'VetsterLoading',

  props: {
    size: {
      type: String,
      default: 'size-8',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
